import { IResponse, IIntegration, consumer } from "@bemap/utils";

const ENDPOINT = '/integrations';

export const getIntegrations = async (): Promise<IResponse> => {
  return consumer('GET', ENDPOINT);
};

export const getIntegration = async (id: string): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, id);
};

export const createIntegration = async (integration: Omit<IIntegration, 'id' | 'created_at' | 'updated_at' | 'team'>): Promise<IResponse> => {
  return consumer('POST', ENDPOINT, integration);
};

export const updateIntegration = async (id: string, integration: Partial<IIntegration>): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, integration, id);
};

export const deleteIntegration = async (id: string): Promise<IResponse> => {
  return consumer('DELETE', ENDPOINT, undefined, id);
}; 